import { Box } from '@elkaso-app/web-design';
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { IOrderTrend } from '../utils/types';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

interface OrderTrendsSectionProps {
  trends: IOrderTrend[];
}

export const OrderTrendsSection = ({ trends }: OrderTrendsSectionProps) => (
  <Box h='250px'>
    <Bar
      options={{
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
        },
        scales: {
          y: { beginAtZero: true, title: { display: true, text: 'Orders' } },
          x: { title: { display: true, text: 'Month' } },
        },
      }}
      data={{
        labels: trends.map((t) => t.month),
        datasets: [
          {
            label: 'Orders',
            data: trends.map((t) => t.orders),
            backgroundColor: 'rgba(54, 162, 235, 0.6)',
            borderColor: 'rgba(54, 162, 235, 1)',
            borderWidth: 1,
          },
        ],
      }}
    />
  </Box>
);
